import { cn } from "@/lib/utils";
import logoImage from "/lovable-uploads/new-logo.png";
import { Link } from "react-router-dom";

interface ModernLogoProps {
  className?: string;
  size?: "sm" | "md" | "lg";
  showTagline?: boolean;
  onClick?: () => void;
}

export const ModernLogo = ({ 
  className, 
  size = "md", 
  showTagline = false,
  onClick
}: ModernLogoProps) => {
  const sizeClasses = {
    sm: "h-8 w-8",
    md: "h-12 w-12", 
    lg: "h-16 w-16"
  };

  const textSizeClasses = {
    sm: "text-lg",
    md: "text-2xl",
    lg: "text-3xl"
  };

  const taglineSizeClasses = {
    sm: "text-[10px]",
    md: "text-xs",
    lg: "text-sm"
  };

  // If onClick is provided, use button, otherwise use Link
  if (onClick) {
    return (
      <button 
        onClick={onClick}
        className={cn("flex items-center gap-3 transition-transform hover:scale-105 cursor-pointer relative z-10", className)}
        aria-label="Go to homepage"
      >
        <img 
          src={logoImage}
          alt="Sortable Logo"
          className={cn(sizeClasses[size], "object-contain rounded-lg")}
        />
        <div className="flex flex-col">
          <h1 className={cn("font-bold bg-gradient-hero bg-clip-text text-transparent tracking-tight", textSizeClasses[size])}>
            Sortable™
          </h1>
          {showTagline && (
            <p className={cn("text-muted-foreground/80 font-medium -mt-1", taglineSizeClasses[size])}>
              Sortable
            </p>
          )}
        </div>
      </button>
    );
  }

  return (
    <Link 
      to="/"
      className={cn("flex items-center gap-3 transition-transform hover:scale-105 cursor-pointer relative z-10", className)}
      aria-label="Go to homepage"
    >
      <img 
        src={logoImage}
        alt="Sortable Logo"
        className={cn(sizeClasses[size], "object-contain rounded-lg")}
      />
      <div className="flex flex-col">
        <h1 className={cn("font-bold bg-gradient-hero bg-clip-text text-transparent tracking-tight", textSizeClasses[size])}>
          Sortable™
        </h1>
        {showTagline && (
          <p className={cn("text-muted-foreground/80 font-medium -mt-1", taglineSizeClasses[size])}>
            Sortable
          </p>
        )}
      </div>
    </Link>
  );
};